export default __webpack_public_path__ + "static/media/MINUSMA_integrated_team.d263b276.jpg";